import React from "react";
import { Box, Typography, CardContent } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { formatCurrency } from "../../../utils/currencyUtils";
import { PaymentStatsDto } from "../../../shared/dtos/payment/PaymentStatsDto";

interface PaymentWidgetProps {
  data: PaymentStatsDto;
}

const PaymentWidget: React.FC<PaymentWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("PAYMENT");
  const Icon = meta.icon;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box sx={{ display: "grid", gap: 2 }}>
          <Box
            sx={{
              p: 1.5,
              borderRadius: 1,
              bgcolor: "success.main",
              color: "success.contrastText",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                Total Inflow Today
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {formatCurrency(data.totalInflowToday)}
              </Typography>
            </Box>
            <ArrowDownwardIcon />
          </Box>

          <Box
            sx={{
              p: 1.5,
              borderRadius: 1,
              bgcolor: "error.main",
              color: "error.contrastText",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                Total Outflow Today
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {formatCurrency(data.totalOutflowToday)}
              </Typography>
            </Box>
            <ArrowUpwardIcon />
          </Box>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default PaymentWidget;
